import React, { useState, useEffect} from 'react';
 
import "../assets/css/styles.table.css"
 
import Layout from './Layout';
//for table
import Box from '@mui/material/Box';
 
import { Typography, Modal, 
} from '@mui/material';
import VirtualizedSelect from 'react-virtualized-select';
import ConfirmationButton from '../components/ConfirmationButton';
import Chip from '@mui/material/Chip';
import Paper from '@mui/material/Paper';
import TagFacesIcon from '@mui/icons-material/TagFaces';
import { styled } from '@mui/material/styles';
import  DynamicSelect  from '../components/DynamicSelect';
//import DynamicDataGridComponent from '../components/DynamicDataGrid'
import GridNumberPaging from '../components/GridNumberPaging.js'
import CustomDialog from '../components/Dialog';
import {useUserListHook} from '../hook/UserListHook'
import Bindcomponent from '../utils/bindcomponent.js';
const UserList = () => {
 
  const [confirmStatusOpen, setConfirmStatusOpen] = useState('');
  const [rows, setRows] = useState([]);
  const [idStatus, setIdStatus] = useState('');
  const [selectedRoles, setSelectedRoles] = useState('');
  const [message, setmessage] = useState('');
  const [typeError, setTypeError] = useState('');
  const [chipData, setChipData] = React.useState([]);
  const {roleAccess,role,  columns,AddProjectData, handleDelete, ListItem, AddStatus, name,setName,email,setEmail,password,setPassword,confirmPassword,setConfirmPassword} = useUserListHook(setmessage,setRows,setTypeError, setSelectedRoles, setIdStatus, setChipData, setConfirmStatusOpen,chipData,idStatus)
  
 
return (
    <>
  <Layout message={message} setmessage={setmessage} tipe={typeError} settipe={setTypeError}>
  <div className='pd'><b>USER LIST</b> 
 
  </div>
 
  <div className="pd">
    <div style={{marginBottom:15}}> <button className='btn btn-success' onClick={AddProjectData} disabled={!roleAccess.CREATE}>Add record</button>
    </div>
    <Box>
      
      <Box sx={{ height: "100%" }} >
        
        <Bindcomponent component='GridNumberPaging' customcolumns={columns} rows={rows} name={"materialgrid"} rowid={"id"}></Bindcomponent>  
          
      </Box>
    </Box>
    </div>
 
        <Bindcomponent component='Dialog' onClose={()=>{
           setChipData([])
        }} open={confirmStatusOpen} setOpen={setConfirmStatusOpen} maxWidth='sm' >
       
          <Typography id="modal-modal-description">
            <form onSubmit={AddStatus} role="form" id="userForm">
            <div class="row">
            <div class="col-md-12">
            <label>Name</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
            </div>
             </div>
             <div class="row">
            <div class="col-md-12">
            <label>Email</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Email"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
            </div>
             </div>
             {idStatus && (
             <div class="row">
            <div class="col-md-12">
                
            <label>Current Password</label>
            <input
                      type="text"
                      className="form-control"
                      placeholder="Password"
                      required
                      value="*****"
                     // onChange={(e) => setPassword(e.target.value)}
                     readOnly
                    />
            </div>
             </div>
             )}
             <div class="row">
            <div class="col-md-12">
            <label>{idStatus && "New"} Password</label>
            <input
                      type="password"
                      className="form-control"
                      placeholder="New Password"
                       
                      value={password}
                      onChange={(e) => setPassword(e.target.value)}
                    />
            </div>
             </div>
           
             <div class="row">
            <div class="col-md-12">
            <label>Confirm Password</label>
            <input
                      type="password"
                      className="form-control"
                      placeholder="Confirm Password"
                       
                      value={confirmPassword}
                      onChange={(e) => setConfirmPassword(e.target.value)}
                    />
            </div>
             </div>
             
             <div class="row">
            <div class="col-md-12">
            <label>Role</label>
            <Bindcomponent component='DynamicSelect' label={"{kode} - {name}"} value={"kode"} selectedvalue={selectedRoles}  onChange={(option) => {
                            if(chipData.filter((item) => item.value == option.value).length == 0){
                              setChipData((prev)=>[...prev, option])
                            }
                        
                            setSelectedRoles(option.value)
                          
                         }}
                         url={"GetRoles/" + role.toUpperCase()} id="roleSelect" disabled={false} required={false}></Bindcomponent>
            {/* <DynamicSelect label={"{kode} - {name}"} value={"kode"} selectedvalue={selectedRoles}  onChange={(option) => {
                            if(chipData.filter((item) => item.value == option.value).length == 0){
                              setChipData((prev)=>[...prev, option])
                            }
                        
                            setSelectedRoles(option.value)
                          
                         }}
                         url={"GetRoles/" + role.toUpperCase()} id="roleSelect" disabled={false} required={false} >

            </DynamicSelect> */}
            
            </div>
             </div>
             <Paper
                sx={{
                  display: 'flex',
                  justifyContent: 'center',
                  flexWrap: 'wrap',
                  listStyle: 'none',
                  p: 0.5,
                  m: 0,
                }}
                component="ul"
              >
                {chipData.map((data) => {
                  let icon;
 
                  return (
                    <ListItem key={data.value}>
                    <Chip
                      icon={icon}
                      label={data.label}
                     // onDelete={data.label === 'React' ? undefined : handleDelete(data)}
                      onDelete={ handleDelete(data)}
                    />
                    </ListItem>
                    );
                  })}
                </Paper>
         <hr></hr>
         <div class="row">
            <div class="col-md-12" style={{textAlign:'right'}}>
            <div style={{marginTop:5,marginBottom:5}}>
            <Bindcomponent component='ConfirmationButton' classname='btn btn-primary' text="Do you want save this data?" type="submit" formid="userForm" id="btnSubmit"> {idStatus ? "UPDATE" : "ADD"}</Bindcomponent>
            {/* <ConfirmationButton classname='btn btn-primary' text="Do you want save this data?" type="submit" formid="userForm" id="btnSubmit">
                {idStatus ? "UPDATE" : "ADD"}
            </ConfirmationButton> */}
                 </div>
            </div>
            
         </div>
         </form>
         
          </Typography>
       
        </Bindcomponent>
 
 
      </Layout>
    </>
  );
};

export default  UserList;